import api from '@/store/api/scheduled-report/bundle'
import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import {map} from 'underscore'

const initialState = () => ({
    scheduledBundles: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        scheduledBundles: state => {
            return map(state.scheduledBundles.data, report => {
                const {time, frequency} = report.run_at
                const localTime = time

                return {
                    ...report,
                    run_at: `${frequency} at ${localTime}`
                }
            })
        },
        pagination: state => state.scheduledBundles.pagination
    },
    actions: {
        /**
         * @param {{}} params
         * @returns {Promise<*>}
         */
        listScheduledBundles: async ({ commit, dispatch}, params) => {
            try {
                const response = await api.listScheduledBundles(params)
                const scheduledBundles = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }
                commit(mutationTypes.SET_SCHEDULED_BUNDLES, scheduledBundles)

                return scheduledBundles
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetScheduledBundles: ({commit}) => commit(mutationTypes.RESET_SCHEDULED_BUNDLES)
    },
    mutations: {
        [mutationTypes.RESET_SCHEDULED_BUNDLES]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_SCHEDULED_BUNDLES]: (state, data) => state.scheduledBundles = data
    }
}
